import React from "react";
import useThemeService from "../../services/theme-service/ThemeService";
import PlaceholderImage from "../image-upload/components/Placeholder";

interface Image {
  id?: string;
  url?: string;
  placeholderImage?: React.FunctionComponent;
  className?: string;
}

export default function DisplayImage(props: Image) {
  const { id, url, placeholderImage, className } = props;
  const { themeClass } = useThemeService();

  return (
    <section className={themeClass(["image-upload", className ? className : ""])}>
      {url ? <img id={id || ""} src={url} alt="" /> : <PlaceholderImage image={placeholderImage} />}
    </section>
  );
}
